import { Component } from '@angular/core';
import { BaseDocumentListComponent } from '@dato-pages/base/base-document-list/base-document-list.component';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';

@Component({
    providers: ServiceBagServices,
    selector: 'app-invoice-list',
    templateUrl: './invoice-list.component.html',
    styleUrls: ['./invoice-list.component.scss', '../../../base/base-document-list/base-document-list.component.scss']
})
export class InvoiceListComponent extends BaseDocumentListComponent {

    constructor(A: ServiceBagService) {
        super(A);
    }
}
